export const LIVE_GAMES_RESET = 'LIVE_GAMES:RESET';
export const LIVE_GAMES_SOCKET_SET = 'LIVE_GAMES:SOCKET:SET';
export const LIVE_GAMES_TABLES_ADD = 'LIVE_GAMES:TABLES:ADD';
export const LIVE_GAMES_TABLES_REMOVE = 'LIVE_GAMES:TABLES:REMOVE';
export const LIVE_GAMES_TABLES_UPDATE = 'LIVE_GAMES:TABLES:UPDATE';
export const LIVE_GAMES_SUBSCRIPTION_ADD = 'LIVE_GAMES:SUBSCRIPTION:ADD';
export const LIVE_GAMES_SUBSCRIPTION_REMOVE = 'LIVE_GAMES:SUBSCRIPTION:REMOVE';
export const LIVE_GAMES_IS_NEED_TO_START_UPDATE = 'LIVE_GAMES:IS_NEED_TO_START:UPDATE';
export const LIVE_GAMES_CONNECTION_STATUS_UPDATE = 'LIVE_GAMES:CONNECTION_STATUS:UPDATE';
export const LIVE_GAMES_RECONNECTION_STATUS_UPDATE = 'LIVE_GAMES:RECONNECTION_STATUS:UPDATE';
export const LIVE_GAMES_IMAGES_TIMESTAMP_UPDATE = 'LIVE_GAMES:IMAGES_TIMESTAMP:UPDATE';
export const LIVE_GAMES_IMAGES_INTERVAL_ID_UPDATE = 'LIVE_GAMES:IMAGES_INTERVAL_ID:UPDATE';

export const updateIsNeedToStart = (isNeedToStart) => ({
    type: LIVE_GAMES_IS_NEED_TO_START_UPDATE,
    payload: isNeedToStart
});

export const resetTables = () => ({
    type: LIVE_GAMES_RESET
});

export const setSocket = (socket) => ({
    type: LIVE_GAMES_SOCKET_SET,
    payload: socket
});

export const updateConnectionStatus = (status) => ({
    type: LIVE_GAMES_CONNECTION_STATUS_UPDATE,
    payload: status
});

export const updateReconnectionStatus = (status) => ({
    type: LIVE_GAMES_RECONNECTION_STATUS_UPDATE,
    payload: status
});

export const addSubscription = ({ tables, subscriptionId, correlationId }) => ({
    type: LIVE_GAMES_SUBSCRIPTION_ADD,
    payload: { tables, subscriptionId, correlationId }
});

export const removeSubscription = (subscriptionIds) => ({
    type: LIVE_GAMES_SUBSCRIPTION_REMOVE,
    payload: subscriptionIds
});

export const updateTables = ({ tables, subscriptionId }) => ({
    type: LIVE_GAMES_TABLES_UPDATE,
    payload: { tables, subscriptionId }
});

export const addTables = ({ tables, subscriptionId }) => ({
    type: LIVE_GAMES_TABLES_ADD,
    payload: { tables, subscriptionId }
});

export const removeTables = ({ tables, subscriptionId }) => ({
    type: LIVE_GAMES_TABLES_REMOVE,
    payload: { tables, subscriptionId }
});

export const updateLiveGamesImagesTimestamp = () => ({
    type: LIVE_GAMES_IMAGES_TIMESTAMP_UPDATE,
    payload: Date.now(),
    isSilent: true
});

export const updateLiveGamesImagesIntervalId = (intervalId) => ({
    type: LIVE_GAMES_IMAGES_INTERVAL_ID_UPDATE,
    payload: intervalId
});
